<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.searchValue" class="input-with-select" size="small">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                            <el-option label="演出ID" :value="1"></el-option>
                            <el-option label="演出名称" :value="2"></el-option>
                            <el-option label="巡演ID" :value="3"></el-option>
                            <el-option label="主题ID" :value="4"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.bvalue" class="input-with-select" size="small">
                        <el-select v-model="params.btype" slot="prepend" placeholder="请选择">
                            <el-option label="艺人名称" :value="2"></el-option>
                            <el-option label="场地名称" :value="4"></el-option>
                            <el-option label="主办名称" :value="6"></el-option>
                            <el-option label="发起人名称" :value="8"></el-option>
                            <el-option label="艺人ID" :value="1"></el-option>
                            <el-option label="场地ID" :value="3"></el-option>
                            <el-option label="主办ID" :value="5"></el-option>
                            <el-option label="发起人ID" :value="7"></el-option>
                            <el-option label="项目负责人" :value="9"></el-option>
                            <el-option label="上线审核人" :value="10"></el-option>
                            <el-option label="代理商ID" :value="11"></el-option>
                            <el-option label="代理商名称" :value="12"></el-option>
							<el-option label="报批方ID" :value="13"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.cityValue" class="input-with-select" size="small">
                        <el-select v-model="params.cityType" slot="prepend" placeholder="请选择">
                            <el-option label="城市" :value="1"></el-option>
                            <el-option label="省份" :value="2"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.contractNo" placeholder="请输入合同编号" size="small"></el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.styleId" placeholder="请选择" size="small">
                        <el-option label="不限制演出风格" :value="0"></el-option>
                        <el-option v-for="(item, index) in styleTagList" :key="index" :label="item.name"
                            :value="item.id"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <!-- <el-select v-model="params.showTypeTagId" placeholder="请选择" size="small">
                        <el-option label="不限制活动类型" value=""></el-option>
                        <el-option v-for="(item, index) in showTypeTagList" :key="index" :label="item.name"
                            :value="item.id"></el-option>
                    </el-select> -->
                    <!-- <el-cascader clearable v-model="params.showTypeTagId" :options="showTypeTagList" :props="{value:'id',label:'name',children:'tags', emitPath:false}" placeholder="不限制活动类型" size="small" style="width:100%"></el-cascader> -->
					
					<el-cascader v-model="styleType" :options="showTypeTagList"
					    :props="{ checkStrictly: true, value: 'id', label: 'name', children: 'tags', emitPath:false }" clearable
					    size="small" placeholder="不限制活动类型"  style="width:100%" ref="cascader" @change="changeStyle">
					</el-cascader>
					
					
					
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.siteTypeTagId" placeholder="请选择" size="small">
                        <el-option label="不限制场地类型" value=""></el-option>
                        <el-option v-for="(item, index) in siteTypeTagList" :key="index" :label="item.name"
                            :value="item.id"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.activityStatus" placeholder="请选择" size="small">
                        <el-option label="不限制演出状态" :value="0"></el-option>
                        <el-option label="仅看待审核的" :value="1"></el-option>
                        <el-option label="仅看预售中的" :value="2"></el-option>
                        <el-option label="仅看已结束的" :value="3"></el-option>
                        <el-option label="仅看已取消的" :value="4"></el-option>
                        <el-option label="仅看未通过的" :value="5"></el-option>
						<el-option label="仅看定时上架的" :value="6"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.sellIdentity" placeholder="请选择" size="small">
                        <el-option label="不限制是否独家" :value="0"></el-option>
                        <el-option label="仅看独家的" :value="1"></el-option>
                        <el-option label="仅看非独家的" :value="2"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.approval" placeholder="请选择" size="small">
                        <el-option label="不限制报批进度" :value="0"></el-option>
                        <el-option label="仅看有批文的" :value="1"></el-option>
                        <el-option label="仅看报批申请中的" :value="2"></el-option>
                        <el-option label="仅看还未申请报批的" :value="3"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.thirdPartner" placeholder="请选择" size="small">
                        <el-option label="不限制外部销售渠道" value=""></el-option>
                        <el-option v-for="(item, index) in thirdAccount" :key="index" :label="`仅看${item.thirdName}的`"
                            :value="item.source"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.balanceType" placeholder="请选择" size="small">
                        <el-option label="不限制是否投资" :value="0"></el-option>
                        <el-option label="仅看投资的" :value="1"></el-option>
                        <el-option label="仅看非投资的" :value="2"></el-option>
                    </el-select>
                </el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-select v-model="params.alternateStatus" placeholder="请选择" size="small">
				        <el-option label="不限制候补状态" value=""></el-option>
				        <el-option label="仅看有候补中票品的演出" :value="1"></el-option>
				        <el-option label="仅看没有候补中票品的演出" :value="0"></el-option>
				    </el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-select v-model="params.preBuyStatus" placeholder="请选择" size="small">
				        <el-option label="不限制定时购状态" value=""></el-option>
				        <el-option label="仅看有可定时购的票品的演出" :value="1"></el-option>
				        <el-option label="仅看没有可定时购票品的演出" :value="2"></el-option>
				        <el-option label="仅看当前定时购开启的演出" :value="3"></el-option>
				        <el-option label="仅看当前定时购关闭的演出" :value="4"></el-option>
				        <el-option label="仅看开启过定时购的演出" :value="5"></el-option>
				    </el-select>
				</el-col>
                <!-- <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.isHide" placeholder="请选择" size="small">
                        <el-option label="不限制是否隐藏" :value="0"></el-option>
                        <el-option label="仅看隐藏的" :value="1"></el-option>
                    </el-select>
                </el-col> -->
                <!-- <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.douyinStatus" placeholder="请选择" size="small">
                        <el-option label="不限制推送抖音生活状态" value=""></el-option>
                        <el-option label="仅看未推送的" :value="0"></el-option>
                        <el-option label="仅看推送中的" :value="1"></el-option>
                        <el-option label="仅看推送成功的" :value="2"></el-option>
                        <el-option label="仅看推送失败的" :value="3"></el-option>
                        <el-option label="仅看已下架的" :value="4"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.aliPushStatus" placeholder="请选择" size="small">
                        <el-option label="不限制是否推送到支付宝小程序" :value="-1"></el-option>
                        <el-option label="仅看从未推送的" :value="0"></el-option>
                        <el-option label="仅看有过推送的" :value="1"></el-option>
                    </el-select>
                </el-col> -->
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">				    
				    <el-cascader  v-model="pushType" :options="pushList"  :props="{value:'id',label:'name',children:'tags'}" size="small" style="width:100%" placeholder="不限制小程序推送状态"></el-cascader>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-select v-model="params.activityChannel" placeholder="不限制演出来源" class="fl fl-big-select" clearable size="small">
						<el-option label="不限制演出来源" value=""></el-option>
				        <el-option v-for="(item, index) in activityChannel" :label="item.value" :key="index" :value="item.key"></el-option>
				    </el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-select v-model="params.sellMode" placeholder="请选择" size="small">
				        <el-option label="不限制售票模式" value=""></el-option>
				        <el-option label="仅限不选座" :value="1"></el-option>
				        <el-option label="仅限随机选座" :value="3"></el-option>
						<el-option label="仅限在线选座" :value="2"></el-option>
				    </el-select>
				</el-col>
                <!-- <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.isSeat" placeholder="请选择" size="small">
                        <el-option label="不限制是否开启选座" value=""></el-option>
                        <el-option label="仅看已开启的" :value="1"></el-option>
                        <el-option label="仅看未开启的" :value="0"></el-option>
                    </el-select>
                </el-col> -->
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.isDelay" placeholder="请选择" size="small">
                        <el-option label="不限制是否有场次延期" value=""></el-option>
                        <el-option label="仅看有场次延期的" :value="1"></el-option>
                        <el-option label="仅看无场次延期的" :value="0"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.firstTicketType" placeholder="不限制开票时间" size="small">
                        <el-option label="不限制开票时间" value=""></el-option>
                        <el-option label="今天开票" :value="0"></el-option>
                        <el-option label="近3日开票" :value="2"></el-option>
                        <el-option label="近7日开票" :value="6"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.salesRatioFilter" placeholder="不限制销售比" size="small">
                        <el-option label="不限制销售比" value=""></el-option>
                        <el-option label="销售比30%以上" :value="30"></el-option>
                        <el-option label="销售比40%以上" :value="40"></el-option>
                        <el-option label="销售比50%以上" :value="50"></el-option>
                        <el-option label="销售比70%以上" :value="70"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="16" :lg="12" :xl="8">
                    <div class="clearfix timeType">
                        <el-input class="input-with-select fl" size="small">
                            <el-select v-model="params.timeType" slot="prepend" placeholder="请选择">
                                <el-option label="开演时间" :value="1"></el-option>
                                <el-option label="发起时间" :value="2"></el-option>
                                <el-option label="审核通过时间" :value="3"></el-option>
                            </el-select>
                        </el-input>
                        <el-date-picker v-model="datetimerange" type="datetimerange" start-placeholder="开始日期"
                            end-placeholder="结束日期" class="fl" size="small" value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']" align="right" unlink-panels>
                        </el-date-picker>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="16" :lg="12" :xl="8">
                    <div class="clearfix timeType">
                        <el-input class="input-with-select fl" size="small">
                            <el-select v-model="params.hideType" slot="prepend" placeholder="请选择">
                                <el-option label="不限制是否隐藏" value=""></el-option>
                                <el-option label="所选终端有任一展示的" :value="1"></el-option>
                                <el-option label="所选终端均展示的" :value="2"></el-option>
                                <el-option label="所选终端有任一隐藏的" :value="3"></el-option>
                                <el-option label="所选终端均隐藏的" :value="4"></el-option>
                            </el-select>
                        </el-input>
                        <el-select v-model="params.hideTerminals" placeholder="请选择终端" class="fl fl-big-select" multiple
                            clearable size="small">
                            <el-option v-for="(item, index) in terminal" :label="item.label" :key="index"
                                :value="item.value"></el-option>
                        </el-select>
                    </div>
                </el-col>
				<el-col :xs="24" :sm="12" :md="16" :lg="12" :xl="8">
				    <div class="clearfix timeType">
				        <el-input class="input-with-select fl" size="small">
				            <el-select v-model="params.sellType" slot="prepend" placeholder="请选择">
				                <el-option label="不限制是否售票" value=""></el-option>
				                <el-option label="所选终端有任一售票的" :value="1"></el-option>
				                <el-option label="所选终端均售票的" :value="2"></el-option>
				                <el-option label="所选终端有任一不售票的" :value="3"></el-option>
				                <el-option label="所选终端均不售票的" :value="4"></el-option>
				            </el-select>
				        </el-input>
				        <el-select v-model="params.sellTerminals" placeholder="请选择终端" class="fl fl-big-select" multiple
				            clearable size="small">
				            <el-option v-for="(item, index) in terminal" :label="item.label" :key="index" v-if="item.value != 'web'"
				                :value="item.value"></el-option>
				        </el-select>
				    </div>
				</el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button v-if="$utils.have('/activity/export')" type="primary" icon="el-icon-download" size="small"
                @click="download" :loading="downLoading">导出演出</el-button>
            <template v-if="$utils.have('/activity/saveTourTheme')">
                <el-button type="primary" icon="el-icon-paperclip" size="small"
                    @click="bindTourEvent">批量绑定巡演</el-button>
                <el-button type="primary" icon="el-icon-collection-tag" size="small"
                    @click="bindThemeEvent">批量绑定主题</el-button>
            </template>
            <el-button v-if="$utils.have('/activity/batchHideActivity')" type="primary" icon="el-icon-remove-outline"
                size="small" @click="batchHideActivity">批量隐藏</el-button>
			<el-button type="primary" icon="el-icon-collection-tag" size="small" @click="batchPushAli" v-if="$utils.have('/activity/ali/batchPush')">批量推送支付宝</el-button>
			<el-button type="primary" icon="el-icon-collection-tag" size="small" @click="batchPushRedbook" v-if="$utils.have('/activity/red/batchPush')">批量推送小红书</el-button>
			<el-button type="primary" icon="el-icon-collection-tag" size="small"  @click="batchPushMeituan" >批量推送美团</el-button>
			<el-button type="primary" icon="el-icon-collection-tag" size="small" @click="batchSetThirds" v-if="$utils.have('/activity/saveAndApplyThirdTemplate')">批量设置第三方销售</el-button>
        </div>
        <div class="page-list-box">
            <el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe
                @selection-change="handleSelectionChange">
                <el-table-column type="selection"></el-table-column>
                <el-table-column prop="id" label="ID"></el-table-column>
                <el-table-column prop="title" label="名称" min-width="200" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-link class="ellipsis title"
                            @click="$refs.H5Preview.show('/pages/activity/detail/detail?activityId=' + scope.row.id)">
                            {{ scope.row.title }}
                        </el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="performer" label="艺人阵容" min-width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="beginShowTime" label="首场开演时间" min-width="150"></el-table-column>
                <!-- <el-table-column prop="cityName" label="城市"></el-table-column> -->
                <el-table-column label="最早开票时间" min-width="220" show-overflow-tooltip>
                    <template slot-scope="{row} = scope">
                        <p>最早开票票品: {{row.firstTicketName }}</p>
                        <p>最早开票时间: {{ row.firstTicketTime }}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="siteName" label="城市&场地" min-width="130" show-overflow-tooltip>
                    <template slot-scope="{row} = scope">
                        {{ row.cityName }} • {{ row.siteName }}
                    </template>
                </el-table-column>
                <el-table-column label="总票数" min-width="140" show-overflow-tooltip>
					<template slot-scope="scope">
					    <p>秀动：{{scope.row.totalTicket}}（赠票：{{scope.row.presentNum}}）</p>
					    <p>主办：{{scope.row.importTicketNum}}</p>
					</template>
				</el-table-column>
                <el-table-column prop="sellTicket" label="秀动售票数" min-width="90"></el-table-column>
                <el-table-column prop="refundTicket" label="秀动退票数" min-width="90"></el-table-column>
				<el-table-column prop="consignRefundTicket" label="托售退票数" min-width="90"></el-table-column>
				<el-table-column prop="income" label="实际收入" min-width="150">
					<template slot-scope="scope">
					    <p v-if="scope.row.income">票品金额：{{scope.row.income}}</p>
					    <p v-if="scope.row.userServiceFee">乐迷服务费：{{scope.row.userServiceFee}}</p>
					</template>
				</el-table-column>
                <el-table-column prop="collectNum" label="收藏数"></el-table-column>
                <el-table-column prop="status" label="演出状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 0">未提交</span>
                        <span v-else-if="scope.row.status == 1" class="color-warning">待审核</span>
                        <span v-else-if="scope.row.status == 2" class="color-success">预售中</span>
                        <span v-else-if="scope.row.status == 3" class="color-info">已结束</span>
                        <span v-else-if="scope.row.status == 4" class="color-danger">已取消</span>
                        <span v-else-if="scope.row.status == 5">未通过</span>						
						<el-tooltip class="item" effect="dark" :content="scope.row.onlineTime" placement="top"  v-else-if="scope.row.status == 6">
						      <span>定时上架</span>
						</el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column prop="tourId" label="是否巡演">
                    <template slot-scope="scope">
                        {{ scope.row.tourId ? '是' : '否' }}
                    </template>
                </el-table-column>
                <el-table-column prop="tourId" label="是否独家">
                    <template slot-scope="scope">
                        {{ scope.row.sellIdentity == 1 ? '是' : '否' }}
                    </template>
                </el-table-column>
                <el-table-column prop="balanceType" label="是否投资">
                    <template slot-scope="scope">
                        <span v-if="scope.row.balanceType == 1">是</span>
                        <span v-else-if="scope.row.balanceType == 2">否</span>
                    </template>
                </el-table-column>
                <el-table-column prop="showTypeTagName" label="活动类型" show-overflow-tooltip min-width="150"></el-table-column>
                <!-- <el-table-column prop="type" label="演出类型" >
				    <template slot-scope="scope">
				        <span v-if="scope.row.type==1">Livehouse</span>
				        <span v-else-if="scope.row.type==2">音乐节</span>
				        <span v-else-if="scope.row.type==3">剧场</span>
				        <span v-else-if="scope.row.type==4">演唱会</span>
				    </template>
				</el-table-column>   -->
                <el-table-column prop="siteTypeTagName" label="场地类型" show-overflow-tooltip min-width="100"></el-table-column>
                <el-table-column prop="contractNo" label="合同编号" show-overflow-tooltip min-width="130"></el-table-column>
                <el-table-column prop="style" label="风格" show-overflow-tooltip></el-table-column>
                <el-table-column prop="host" label="主办" min-width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="startUser" label="发起人" show-overflow-tooltip></el-table-column>

                <el-table-column label="售票终端">
                    <template slot-scope="{row} = scope">
                        <!-- APP
                        <span v-if="row.wapSellStatus == 1">、WAPCN</span>
                        <span v-if="row.douyinActivityStatus == 2 && row.byteSellStatus == 1">、抖音小程序</span>
                        <span v-if="row.aliSellStatus == 1">、支付宝小程序</span> -->
                        <el-popover title="售票终端明细" width="400" trigger="hover" placement="top">
                            <table style="width: 100%;" class="info-table">
                                <tr>
                                    <th>APP</th>
                                    <td class="color-success">
                                        售票
                                    </td>
                                </tr>
                                <tr>
                                    <th>WAPCN</th>
                                    <td>
                                        <span v-if="row.wapSellStatus == 1" class="color-success">售票</span>
                                        <span v-else>不可售票</span>
                                    </td>
                                </tr>
                                
                                <tr>
                                    <th>支付宝小程序</th>
                                    <td>
                                        <span v-if="row.aliSellStatus == 1" class="color-success">售票</span>
                                        <span v-else>不可售票</span>
                                    </td>
                                </tr>
                                <tr>
                                    <th>抖音小程序</th>
                                    <td>
                                        <span v-if="row.byteSellStatus == 1" class="color-success">售票</span>
                                        <span v-else>不可售票</span>
                                    </td>
                                </tr>
                                <tr>
                                    <th>微信小程序</th>
                                    <td>
                                        <span v-if="row.wxSellStatus == 1" class="color-success">售票</span>
                                        <span v-else>不可售票</span>
                                    </td>
                                </tr>
								<tr>
								    <th>小红书小程序</th>
								    <td>
								        <span v-if="row.redSellStatus == 1" class="color-success">售票</span>
								        <span v-else>不可售票</span>
								    </td>
								</tr>
								<tr>
								    <th>美团小程序</th>
								    <td>
								        <span v-if="row.meiTuanSellStatus == 1" class="color-success">售票</span>
								        <span v-else>不可售票</span>
								    </td>
								</tr>
								<tr>
								    <th>太校园小程序</th>
								    <td>
								        <span v-if="row.taiYouthSellStatus == 1" class="color-success">售票</span>
								        <span v-else>不可售票</span>
								    </td>
								</tr>
                                <tr>
                                    <th>WEB</th>
                                    <td>
                                        不支持售票
                                    </td>
                                </tr>
                            </table>
                            <el-button type="text" slot="reference" size="mini">查看详情</el-button>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column label="终端展示">
                    <template slot-scope="{row} = scope">
                        <!-- <div> APP：
                            <span v-if="row.appHideType == 0">正常展示</span>
                            <span v-else-if="row.appHideType == 1">列表隐藏</span>
                            <span v-else-if="row.appHideType == 2">列表和详情隐藏</span>
                        </div>
                        <div> WAPCN：
                            <span v-if="row.wapHideType == 0">正常展示</span>
                            <span v-else-if="row.wapHideType == 1">列表隐藏</span>
                            <span v-else-if="row.wapHideType == 2">列表和详情隐藏</span>
                        </div> -->
                        <el-popover title="终端展示明细" width="400" trigger="hover" placement="top">
                            <table style="width: 100%;" class="info-table">
                                <tr>
                                    <th>APP</th>
                                    <td>
                                        <span v-if="row.appHideType == 0">正常展示</span>
                                        <span v-else-if="row.appHideType == 1">列表隐藏</span>
                                        <span v-else-if="row.appHideType == 2">列表和详情隐藏</span>
                                    </td>
                                </tr>
                                <tr>
                                    <th>WAPCN</th>
                                    <td>
                                        <span v-if="row.wapHideType == 0">正常展示</span>
                                        <span v-else-if="row.wapHideType == 1">列表隐藏</span>
                                        <span v-else-if="row.wapHideType == 2">列表和详情隐藏</span>
                                    </td>
                                </tr>
                                <tr>
                                    <th>微信小程序</th>
                                    <td>
                                        <span v-if="row.wxHideType == 0">正常展示</span>
                                        <span v-else-if="row.wxHideType == 1">列表隐藏</span>
                                        <span v-else-if="row.wxHideType == 2">列表和详情隐藏</span>
                                    </td>
                                </tr>
                                <tr>
                                    <th>支付宝小程序</th>
                                    <td>
                                        <span v-if="row.aliHideType == 0">正常展示</span>
                                        <span v-else-if="row.aliHideType == 1">列表隐藏</span>
                                        <span v-else-if="row.aliHideType == 2">列表和详情隐藏</span>
                                    </td>
                                </tr>
                                <tr>
                                    <th>抖音小程序</th>
                                    <td>
                                        <span v-if="row.byteHideType == 0">正常展示</span>
                                        <span v-else-if="row.byteHideType == 1">列表隐藏</span>
                                        <span v-else-if="row.byteHideType == 2">列表和详情隐藏</span>
                                    </td>
                                    
                                </tr>
								<tr>
								    <th>小红书小程序</th>
								    <td>
								        <span v-if="row.redHideType == 0">正常展示</span>
								        <span v-else-if="row.redHideType == 1">列表隐藏</span>
								        <span v-else-if="row.redHideType == 2">列表和详情隐藏</span>
								    </td>								    
								</tr>
								<tr>
								    <th>美团小程序</th>
								    <td>
								        <span v-if="row.meiTuanHideType == 0">正常展示</span>
								        <span v-else-if="row.meiTuanHideType == 1">列表隐藏</span>
								        <span v-else-if="row.meiTuanHideType == 2">列表和详情隐藏</span>
								    </td>								    
								</tr>
								<tr>
								    <th>太校园小程序</th>
								    <td>
								        <span v-if="row.taiYouthHideType == 0">正常展示</span>
								        <span v-else-if="row.taiYouthHideType == 1">列表隐藏</span>
								        <span v-else-if="row.taiYouthHideType == 2">列表和详情隐藏</span>
								    </td>
								</tr>
                                <tr>
                                    <th>WEB</th>
                                    <td>
                                        <span v-if="row.webHideType == 0">正常展示</span>
                                        <span v-else-if="row.webHideType == 1">列表隐藏</span>
                                        <span v-else-if="row.webHideType == 2">列表和详情隐藏</span>
                                    </td>
                                </tr>
                            </table>
                            <el-button type="text" slot="reference" size="mini">查看详情</el-button>
                        </el-popover>
                    </template>
                </el-table-column>

                <!-- <el-table-column prop="webHideType" label="网页端隐藏设置" min-width="110">
				    <template slot-scope="scope">
				        <span v-if="scope.row.webHideType == 0">不隐藏</span>
				        <span v-else-if="scope.row.webHideType == 1">列表隐藏</span>
				        <span v-else-if="scope.row.webHideType == 2">列表和详情隐藏</span>
				    </template>
				</el-table-column> -->
                <el-table-column prop="approval" label="报批进度" min-width="150" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <p v-if="scope.row.approval == 0">未知 <span class="ML10" v-if="scope.row.approvalName">（报批方： {{scope.row.approvalName}}）</span></p>
                        <p v-else-if="scope.row.approval == 1" class="color-success">有批文<span class="ML10 color-normal" v-if="scope.row.approvalName">（报批方： {{scope.row.approvalName}}）</span><span v-else class="ML10 color-normal">（报批方：暂无）</span></p>
                        <p v-else-if="scope.row.approval == 2">报批申请中<span class="ML10" v-if="scope.row.approvalName">（报批方： {{scope.row.approvalName}}）</span><span v-else class="ML10 color-normal">（报批方：暂无）</span></p>
                        <p v-else-if="scope.row.approval == 3">还未申请报批<span class="ML10" v-if="scope.row.approvalName">（报批方： {{scope.row.approvalName}}）</span></p>
                    </template>
                </el-table-column>
                <el-table-column prop="thirdName" label="接入第三方" min-width="100" show-overflow-tooltip></el-table-column>
                <el-table-column prop="passAuditTime" label="审核通过时间" min-width="150"></el-table-column>
                <el-table-column prop="createTime" label="发起时间" min-width="150"></el-table-column>
                <el-table-column prop="principalName" label="项目负责人" show-overflow-tooltip
                    min-width="90"></el-table-column>
                <el-table-column prop="auditorName" label="上线审核人" show-overflow-tooltip
                    min-width="90"></el-table-column>
                <el-table-column fixed="right" label="操作" width="250">
                    <template slot-scope="scope">
                        <edit-dropdown :params="params" :id="scope.row.id" :channelName="scope.row.channelName"></edit-dropdown>
                        <!-- <el-button type="text" size="small" icon="el-icon-view" @click="view(scope.row)">预览</el-button> 4505365612-->
                        <el-button type="text" size="small" icon="el-icon-share"
                            @click="share(scope.row)" v-if="scope.row.status != 1">演出推广</el-button>
						<el-button
						    type="text"
						    size="small"
							icon="el-icon-share"
						    @click="$refs.WapLink.show(scope.row)"
							v-if="scope.row.status == 1"
						    >演出预览</el-button
						>
                        <el-button v-if="$utils.have('/activity/exportTicket')" type="text" size="small" icon="el-icon-download" @click="exportTicket(scope.row.id)">导出全量票</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div v-if="data" class="page-pagination-box">
            <el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
                :current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
            </el-pagination>
        </div>

        <bind-tour :activityIds="activityIds" ref="bindTour" @onUpdate="getDataList"></bind-tour>
        <bind-theme :activityIds="activityIds" ref="bindTheme" @onUpdate="getDataList"></bind-theme>
        <batch-hide-activity :activityIds="activityIds" ref="batchHideActivity"
            @onUpdate="getDataList"></batch-hide-activity>
        <activity-promotion ref="ActivityPromotion"></activity-promotion>
        <H5Preview ref="H5Preview"></H5Preview>
		<push-ali ref="pushAli"></push-ali>
		<push-redbook ref="PushRedbook"></push-redbook>
		<push-meituan ref="PushMeituan"></push-meituan>
		<set-thirds ref="SetThirds" :activityIds="activityIds" @onUpdate="getDataList" :tourIds="tourIds"></set-thirds>
		<wap-link ref="WapLink"></wap-link>
    </div>
</template>

<script>
import BindTour from './components/bind-tour';
import BindTheme from './components/bind-theme';
import SetThirds from './components/set-thirds';
import BatchHideActivity from './components/batch-hide-activity';
import { fetchStyleList, fetchThirdAccount } from '@/assets/js/commonApi';
import ActivityPromotion  from "./components/activity-promotion.vue";
import H5Preview from '@/components/H5Preview';
import EditDropdown from './components/edit-dropdown.vue';
import PushAli from './components/push-ali';
import PushRedbook from './components/push-redbook';
import PushMeituan from './components/push-meituan';
import {downloadFileTmp} from '@/assets/js/commonApi.js';
import WapLink from "./components/wap-link.vue";
const defaultParams = {
    pageNo: 1,
    searchType: 1,
    searchValue: '',
    cityValue: '',
    cityType: 1,
    timeType: 1,
    beginTime: '',
    endTime: '',
    sellIdentity: 0,
    contractNo: '',
    // activityType: 0,
    activityStatus: 0,
    approval: 0,
    thirdPartner: '',
    btype: 1,
    bvalue: '',
    styleId: 0,
    // isHide: 0,
    hideType: "",
    hideTerminals: [],
	sellType: "",
	sellTerminals: [],
    balanceType: 0,
    //showTypeTagId: '',
	showTypeTagParentId: '',
	showTypeTagId: '',
    siteTypeTagId: '',
    // douyinStatus: '',
    // aliPushStatus: -1,
    //isSeat: '',
	sellMode:'',
    isDelay: '',
	thirdMiniType:'',
	thirdMiniStatus:'',
	activityChannel:"",
	alternateStatus:'',
	preBuyStatus:'',
	firstTicketType: '',
	salesRatioFilter: ''
	
}
export default {
    components: { BindTour, BindTheme, ActivityPromotion, H5Preview, BatchHideActivity, EditDropdown ,PushAli ,WapLink ,PushRedbook,PushMeituan, SetThirds},
    data() {
        return {
            data: null,
            dataList: null,
            params: {
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                searchType: parseInt(this.$route.query.searchType || 1),
                searchValue: this.$route.query.searchValue || '',
                cityValue: this.$route.query.cityValue || '',
                cityType: parseInt(this.$route.query.cityType || 1),
                timeType: parseInt(this.$route.query.timeType || 1),
                beginTime: this.$route.query.beginTime || '',
                endTime: this.$route.query.endTime || '',
                sellIdentity: this.$route.query.sellIdentity ? parseInt(this.$route.query.sellIdentity) : 0,
                contractNo: this.$route.query.contractNo || '',
                // activityType: parseInt(this.$route.query.activityType || 0),
                activityStatus: parseInt(this.$route.query.activityStatus || 0),
                approval: parseInt(this.$route.query.approval || 0) || 0,
                thirdPartner: this.$route.query.thirdPartner || '',
                btype: parseInt(this.$route.query.btype || 1),
                bvalue: this.$route.query.bvalue || '',
                styleId: parseInt(this.$route.query.styleId || 0),
                // isHide: parseInt(this.$route.query.isHide || 0),
                hideType: parseInt(this.$route.query.hideType) || "",
				sellType: parseInt(this.$route.query.sellType) || "",
                balanceType: parseInt(this.$route.query.balanceType || 0),
				alternateStatus:parseInt(this.$route.query.alternateStatus) || "",
				preBuyStatus:parseInt(this.$route.query.preBuyStatus) || "",
                //showTypeTagId: parseInt(this.$route.query.showTypeTagId) || "",
                siteTypeTagId: parseInt(this.$route.query.siteTypeTagId) || "",
                // douyinStatus: parseInt(this.$route.query.douyinStatus) || "",
                // aliPushStatus: parseInt(this.$route.query.aliPushStatus) || -1,
                //isSeat: parseInt(this.$route.query.isSeat) || "",
				sellMode: parseInt(this.$route.query.sellMode) || "",
                isDelay: parseInt(this.$route.query.isDelay) || "",
                firstTicketType: this.$route.query.firstTicketType ? parseInt(this.$route.query.firstTicketType) : "",
                salesRatioFilter: this.$route.query.salesRatioFilter ? parseInt(this.$route.query.salesRatioFilter) : "",
            },
            listLoading: true,
            datetimerange: [this.$route.query.beginTime || '', this.$route.query.endTime || ''],
            activityIds: [], //选中演出ID集合
			tourIds:[],
			thirdNameArr:[],//第三方批量设置收集第三方名称合集
            styleTagList: [], //风格列表集合
            downLoading: false,
            sswap: process.env.VUE_APP_SSWAP_URL,
            thirdAccount: [],
            showTypeTagList: [],
            siteTypeTagList: [],
			pushType:[],
			styleType:[],

            terminal: [{
                label: 'APP',
                value: 'app'
            }, {
                label: 'WAPCN',
                value: 'wap'
            }, {
                label: 'WEB',
                value: 'web'
            }, {
                label: '微信小程序',
                value: 'wechat_mini'
            }, {
                label: '抖音小程序',
                value: 'byte_mini'
            }, {
                label: '支付宝小程序',
                value: 'ali_mini'
            }, {
                label: '小红书小程序',
                value: 'red_booklet_mini'
            }, {
                label: '美团小程序',
                value: 'meituan_mini'
            }],
			activityChannel:[],
			pushList:[
			    {
			        "id": 0,
			        "name": "抖音小程序",
			        "tags": [
			            {
			                "id": 2,
			                "name": "仅看推送成功的"
			            },
			            {
			                "id": 0,
			                "name": "仅看未推送的"
			            },
			            {
			                "id": 1,
			                "name": "仅看推送中的"
			            },
			            {
			                "id": 3,
			                "name": "仅看推送失败的"
			            },
						{
						    "id": 4,
						    "name": "仅看下架的"
						}
			        ]
			    },
			    {
			        "id": 1,
			        "name": "支付宝小程序",
			        "tags": [
			            {
			                "id": 0,
			                "name": "仅看未推送过的"
			            },
			            {
			                "id": 1,
			                "name": "仅看推送过的"
			            }
			        ]
			    },
			    {
			        "id": 2,
			        "name": "小红书小程序",
			        "tags": [
			            {
			                "id": 2,
			                "name": "仅看推送成功的"
			            },
			            {
			                "id": 1,
			                "name": "仅看未推送的"
			            },
			            {
			                "id": 3,
			                "name": "仅看推送失败的"
			            },
			            {
			                "id": 4,
			                "name": "仅看下架的"
			            },
                        {
			                "id": 5,
			                "name": "仅看推送中的"
			            }
			        ]
			    },
				{
				    "id": 3,
				    "name": "美团小程序",
				    "tags": [
				        {
				            "id": 2,
				            "name": "仅看推送成功的"
				        },
				        {
				            "id": 0,
				            "name": "仅看未推送的"
				        },
				        {
				            "id": 3,
				            "name": "仅看推送失败的"
				        },
				        {
				            "id": 4,
				            "name": "仅看下架的"
				        },
				        {
				            "id": 1,
				            "name": "仅看推送中的"
				        }
				    ]
				}
			]
			   
        }
    },
    mounted() {
        this.getShowTypeTag();
        this.getSiteTypeTag();
        this.getStyleTagList();
        this.getThirdAccount();
		this.getChannel();
        this.getDataList();
    },
    methods: {
        //获取活动类型
        getShowTypeTag() {
            this.$request({
                url: "/styleTag/showType/all",
                method: "post",
                params: { isAll: 1 }
            }).then(res => {
                const { state, result } = res.data;
                if (state == 1) {
                    this.showTypeTagList = result || []
                }
            })
        },
        //获取场地类型
        getSiteTypeTag() {
            this.$request({
                url: "/styleTag/showType/site/all",
                method: "post",
                params: { isAll: 1 }
            }).then(res => {
                const { state, result } = res.data;
                if (state == 1) {
                    this.siteTypeTagList = result || []
                }
            })
        },
		//获取演出渠道
		getChannel() {
			this.$request({
				url: "/common/activitySource",
				method: "post",
				
			}).then(res => {
				const { state, result } = res.data;
				if (state == 1) {
					this.activityChannel = result || []
				}
			})
		},
		
        //获取第三方平台
        getThirdAccount() {
            fetchThirdAccount({ isThird: 1 })
                .then((res) => {
                    const { state, result } = res.data;
                    if (state == 1 && result) {
                        this.thirdAccount = result.thirdAccounts || [];
                    } else {
                        // this.$message.error(msg || "请求失败");
                    }
                })
        },
        //获取风格列表
        async getStyleTagList() {
            const res = await fetchStyleList();
            const { state, result } = res.data;
            if (state && state == 1) {
                this.styleTagList = result[0].childList;
            }
        },
		changeStyle(){
			var item = this.$refs.cascader.getCheckedNodes()[0].path;
			this.styleType = item
		},
        //获取列表
        getDataList() {
			console.log(this.styleType)
            this.listLoading = true;
            this.params = {
                ...this.params,
                beginTime: this.datetimerange && this.datetimerange[0] || '',
                endTime: this.datetimerange && this.datetimerange[1] || '',
				thirdMiniType:this.pushType[0],
				thirdMiniStatus:this.pushType[1],
				showTypeTagParentId:this.styleType[0],
				showTypeTagId:this.styleType[1],
            }
            this.$request({
                url: "/activity/list",
                method: "POST",
                data: {
                    ...this.params
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];

                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.datetimerange = [];
			this.pushType = []
			this.styleType = []
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
				activityChannel:''
            };
            this.getDataList();
        },
        //全选、反选
        handleSelectionChange(val) {
            this.tourIds = []
			this.thirdNameArr = []
			this.activityIds = val.map(v => v.id);			
			val.map( v => {
				 if(v.tourId){
					 this.tourIds.push(v.tourId)
				 }
				 if(v.channelName){
					this.thirdNameArr.push(v.channelName)
				 }
			 })			 
        },
        //批量绑定巡演
        bindTourEvent() {
            if (this.activityIds.length < 1) {
                return this.$message.warning('请选择需要绑定巡演的演出');
            } else {
                this.$refs.bindTour.show()
            }
        },
        //批量绑定主题
        bindThemeEvent() {
            if (this.activityIds.length < 1) {
                return this.$message.warning('请选择需要绑定主题的演出');
            } else {
                this.$refs.bindTheme.show()
            }
        },
        //批量隐藏
        batchHideActivity() {
            if (this.activityIds.length < 1) {
                return this.$message.warning('请选择需要隐藏的演出');
            } else {
                this.$refs.batchHideActivity.show()
            }
        },
		//
		batchPushAli(){
			this.$refs.pushAli.show()
		},
		batchPushRedbook(){
			this.$refs.PushRedbook.show()
        },
		batchPushMeituan(){
			this.$refs.PushMeituan.show()
		},
		batchSetThirds(){
			if (this.activityIds.length < 1) {
                return this.$message.warning('请选择需要设置的演出');
			}else if( this.thirdNameArr.length > 0 ){
			    return this.$message.warning('所选演出包含云仓控制演出暂不支持推送第三方渠道！');	
			}  else {
                this.$refs.SetThirds.show()
			}	
		},
        //导出演出
        download() {
            this.downLoading = true;
            this.$request({
                url: "/activity/export",
                method: "POST",
                data: {
                    ...this.params,
                    beginTime: this.datetimerange && this.datetimerange[0] || '',
                    endTime: this.datetimerange && this.datetimerange[1] || ''
                },
            })
                .then((res) => {
                    const { state, msg } = res.data;
                    if (state == 1) {
                        this.$confirm('下载任务创建成功,可以在下载任务列表查看', '提示', {
                            confirmButtonText: '立即查看',
                            cancelButtonText: '稍后再看',
                            type: 'success',
                            center: true,
                            closeOnClickModal: false
                        }).then(() => {
                            this.$router.push({ path: '/workbench/downloadList' })
                        }).catch(() => { })
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.downLoading = false;
                });
        },
        //导出全量票
        async exportTicket(id){
            let filePath;
            const res = await this.$request({
                url:'/activity/exportTicket',
                params: {
                    activityId: id
                },
                method: 'post',
            })
                .catch(err => {
                    this.$message({message: err.message, type: 'error'});
                })
            const{state,msg,result:{url}} = res.data;
            if(state == 1 &&  url){
                filePath = url;
            }else{
                return this.$message.error(msg || '下载失败');
            }   

            await downloadFileTmp(filePath,id+'-全量票.'+this.$utils.getFileType(filePath));
        },
        //预览
        view(item) {
            this.$refs.H5Preview.show('/pages/activity/detail/detail?activityId=' + item.id + '&previewFrom=ht')
        },
		
        //推广
        share(item) {
            this.$refs.ActivityPromotion.show({
                ...item,
				showWechart:1,
                qrCodeUrl: this.sswap + '/pages/activity/detail/detail?activityId=' + item.id
            })
        },
		
    }
}
</script>